import { Provider } from "components/request-lookup/RequestLookupContext";
import { RequestLookupList } from "components/request-lookup/RequestLookupList";

export const RequestLookups = () => {
    return (
        <Provider>
            <RequestLookupList />
        </Provider>
    );
};
